import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_RECON_DETAILS, GET_RECON_DETAILS_SUCCESS, GET_RECON_DETAILS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getReconDetails({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-recon-details`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response?.status === 200) {
      yield put({
        type: GET_RECON_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RECON_DETAILS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RECON_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetReconDetails() {
  yield takeEvery(GET_RECON_DETAILS, getReconDetails);
}

function* getReconDetailsSaga() {
  yield all([fork(watchGetReconDetails)]);
}

export default getReconDetailsSaga;
